import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { interval } from 'rxjs';

import {Encrypt,Decrypt} from '../../pages/functions/functions.js'
import { LogsService } from './logs.service.js';
import { filter, take } from 'rxjs/operators';
import { LogsSessionService } from './logs-session.service';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

   constructor(
    private router: Router,
    private logservice: LogsSessionService,
  ) {}

  initSessionTracking(getArgumentosRuta: () => Promise<any>, 
                      getAutorizations: () => void, 
                      getAlertsMant: () => void,
                       alarmaError: () => void): void {

    this.router.events
      .pipe(filter(event => event instanceof RoutesRecognized))
      .subscribe(async (event: any) => {
        const routeUrl = event.url?.toString() || '';
        localStorage.setItem('rout', Encrypt(routeUrl));

        const userIdEncrypted = localStorage.getItem('key_id');
        const userId = userIdEncrypted ? Decrypt(userIdEncrypted) : '';

        const data = {
          access: await getArgumentosRuta(),
          move: 'Navegacion',
          observation: routeUrl,
          user_id: userId
        };

        if (localStorage.getItem('token')) {
          getAutorizations();

          const intervalo = 60_000; // 1 minuto
          interval(intervalo)
            .pipe(take(1))
            .subscribe(() => {
              getAlertsMant();
              alarmaError();
            });
        }

        // Registrar logs (versión RxJS 6 compatible)
        try {
          await this.logservice.postLogs_Sessions(data).toPromise();
        } catch (error) {
          console.error('Error al registrar log de sesión:', error);
        }
      });
  }
}